type FixedVantaGlobeBackgroundProps = {
  theme?: "light" | "dark" | "material-dark";
};

export function FixedVantaGlobeBackground({
  theme = "light",
}: FixedVantaGlobeBackgroundProps) {
  const isMaterialDark = theme === "material-dark";
  const isDark = theme !== "light";

  return (
    <div aria-hidden="true" className="pointer-events-none fixed inset-0 -z-20 overflow-hidden">
      <div
        className={`absolute inset-0 ${
          isMaterialDark
            ? "bg-[linear-gradient(180deg,#121212_0%,#1e1e1e_48%,#121212_100%)]"
            : isDark
            ? "bg-[linear-gradient(180deg,#08111b_0%,#0d1724_52%,#111d2c_100%)]"
            : "bg-[linear-gradient(180deg,#ffffff_0%,#f8fafc_48%,#f6f8ff_100%)]"
        }`}
      />
      <div
        className={`absolute inset-0 ${
          isMaterialDark
            ? "bg-[radial-gradient(circle_at_12%_14%,rgba(255,255,255,0.035),transparent_28%),radial-gradient(circle_at_82%_18%,rgba(255,255,255,0.02),transparent_24%),radial-gradient(circle_at_24%_82%,rgba(255,255,255,0.018),transparent_20%)]"
            : isDark
            ? "bg-[radial-gradient(circle_at_12%_14%,rgba(255,206,2,0.08),transparent_22%),radial-gradient(circle_at_82%_18%,rgba(0,102,179,0.18),transparent_24%),radial-gradient(circle_at_24%_82%,rgba(88,87,249,0.1),transparent_20%)]"
            : "bg-[radial-gradient(circle_at_12%_14%,rgba(251,84,87,0.05),transparent_20%),radial-gradient(circle_at_82%_18%,rgba(88,87,249,0.06),transparent_22%),radial-gradient(circle_at_24%_82%,rgba(59,130,246,0.05),transparent_18%)]"
        }`}
      />
      <div
        className={`absolute inset-0 bg-[linear-gradient(rgba(148,163,184,0.04)_1px,transparent_1px),linear-gradient(90deg,rgba(148,163,184,0.04)_1px,transparent_1px)] bg-[size:72px_72px] [mask-image:radial-gradient(circle_at_center,black,transparent_78%)] ${
          isMaterialDark ? "opacity-12" : isDark ? "opacity-30" : "opacity-18"
        }`}
      />
    </div>
  );
}
